<template>
  <div class="box bg-white border border-gray-200 rounded-lg px-4 py-4 h-full flex flex-col justify-between" :class="align === 'center' ? 'items-center' : 'items-start'" data-pdf-stat>
    <slot name="content">
      <div class="flex items-start w-full" :class="align === 'center' ? 'flex-col items-center' : 'justify-between'">
        <div class="flex items-center gap-2">
          <span v-if="$slots.icon" class="text-primary-1">
            <slot name="icon" />
          </span>
          <p class="text-sm text-gray-600 leading-tight" data-pdf-label>{{ label }}</p>
        </div>

        <slot name="iconRight">
        </slot>
      </div>

      <div class="mt-3" :class="align === 'center' ? 'text-center' : ''">
        <div class="text-3xl leading-none break-all" :class="valueColor ? '' : 'text-dark'"
          :style="valueColor ? { color: valueColor } : {}" data-pdf-value>
          {{ formattedValue }}
        </div>
        <p v-if="unit" class="text-sm text-gray-600 mt-2" data-pdf-unit>{{ unit }}</p>
      </div>
    </slot>
  </div>
</template>

<script setup>
import { globalNumDecFixed } from "@/utils/format-number";
import { computed } from "vue";

const props = defineProps({
  label: { type: String, default: "" },
  value: { type: [Number, String], default: 0 },
  unit: { type: String, default: "" },
  align: { type: String, default: "center" }, // 'center' | 'left'
  showArrow: { type: Boolean, default: false },
  valueColor: { type: String, default: "" },

});

const formattedValue = computed(() => {
  if (typeof props.value === "number") return globalNumDecFixed(props.value);
  return props.value;
});
</script>
